import React, { useContext, useEffect, Fragment } from "react";

import SpotReviewItemV2 from "./SpotReviewItemV2";
import SpotContext from "../../context/spot/spotReviewContext";
import Box from '@mui/material/Box';

const SpotReviews = ({ id, fromPath }) => {

  const spotContext = useContext(SpotContext);
  const { getSpotReviewsForId, spotReviews, loading } = spotContext;

  useEffect(() => {
    getSpotReviewsForId(id);
    // eslint-disable-next-line
  }, []);

  if (spotReviews !== null && spotReviews.length === 0 && !loading) {
    return (
      <Fragment>
        <h4>No spot reviews to show</h4>
      </Fragment>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: 'repeat(2, 1fr)',
        },
        gap: 3,
        overflow: 'hidden',
      }}
    >
      {spotReviews !== null && !loading ? (
        spotReviews.map((spotReview) => (
          <SpotReviewItemV2 key={spotReview.id} spotReview={spotReview} fromPath={fromPath} />
        ))
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <div className="preloader-wrapper big active">
            <div className="spinner-layer spinner-blue-only">
              <div className="circle-clipper left">
                <div className="circle"></div>
              </div>
              <div className="gap-patch">
                <div className="circle"></div>
              </div>
              <div className="circle-clipper right">
                <div className="circle"></div>
              </div>
            </div>
          </div>
        </Box>
      )}
    </Box>
  );
};

export default SpotReviews;
